module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-list-small-wrapper",
    attrs: {
      "data-live-list-small-wrapper": ""
    }
  }, [_c('ul', {
    staticClass: "live-list-small"
  }, [_vm._l((_vm.items), function(item) {
    return [(_vm.itemIsCanceled(item)) ? _c('slider-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    }) : (_vm.itemHasLink(item)) ? _c('slider-item-link', {
      key: item.id,
      attrs: {
        "item": item
      }
    }) : _c('slider-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b83778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderContent.vue
// module id = 94
// module chunks = 1